import { render, staticRenderFns } from "./DashboardViewBills.vue?vue&type=template&id=a36dc60a"
import script from "./DashboardViewBills.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardViewBills.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports